var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3399 14.6282L18.3399 12.9682C18.1299 12.5982 17.9399 11.8982 17.9399 11.4882V8.95818C17.9399 6.60818 16.5599 4.57818 14.5699 3.62818C14.0499 2.70818 13.0899 2.13818 11.9899 2.13818C10.8999 2.13818 9.91994 2.72818 9.39994 3.65818C7.44994 4.62818 6.09994 6.63818 6.09994 8.95818V11.4882C6.09994 11.8982 5.90994 12.5982 5.69994 12.9582L4.68994 14.6282C4.28994 15.2982 4.19994 16.0382 4.44994 16.7182C4.68994 17.3882 5.25994 17.9082 5.99994 18.1582C7.93994 18.8182 9.97994 19.1382 12.0199 19.1382C14.0599 19.1382 16.0999 18.8182 18.0399 18.1682C18.7399 17.9382 19.2799 17.4082 19.5399 16.7182C19.7999 16.0282 19.7299 15.2682 19.3399 14.6282Z",
    fill: "#464650"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8302 20.1482C14.4102 21.3082 13.3002 22.1382 12.0002 22.1382C11.2102 22.1382 10.4302 21.8182 9.88018 21.2482C9.56018 20.9482 9.32018 20.5482 9.18018 20.1382C9.31018 20.1582 9.44018 20.1682 9.58018 20.1882C9.81018 20.2182 10.0502 20.2482 10.2902 20.2682C10.8602 20.3182 11.4402 20.3482 12.0202 20.3482C12.5902 20.3482 13.1602 20.3182 13.7202 20.2682C13.9302 20.2482 14.1402 20.2382 14.3402 20.2082C14.5002 20.1882 14.6602 20.1682 14.8302 20.1482Z",
    fill: "#464650"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.24e4476c2c0912de7d4d05a0cb515d5a.svg";
export { ForwardRef as ReactComponent };